import { usePostHog as usePostHogLib } from 'posthog-js/react';

export const usePostHog = () => {
  const postHog = usePostHogLib();
  return postHog;
};
